import { isJottacloudAndroidApp } from '@jotta/utils/jottacloudAndroidApp'

/** The app intercepts this and opens its in-app product list. */
export const JOTTACLOUD_ANDROID_PRODUCTS_URL = 'https://jottacloud.com/iap'

/**
 * Play-billed and free Jottacloud accounts buy in the app when it opened the
 * webview with ?iap=true. The app adds that param only for the Jottacloud
 * flavor in those cases. Brand, user agent, and payment are checked again
 * here so a copied or stale link stays on web checkout.
 */
export function androidProductsDeeplink({
  brandCode,
  userAgent,
  paymentMethodCase,
  isFreeAccount,
  iapRequested,
}: {
  brandCode: string
  userAgent: string
  paymentMethodCase: string | undefined
  isFreeAccount: boolean
  iapRequested: boolean
}): string | undefined {
  if (
    brandCode !== 'JOTTACLOUD' ||
    !iapRequested ||
    !isJottacloudAndroidApp(userAgent)
  ) {
    return undefined
  }
  if (paymentMethodCase !== 'playStoreBilling' && !isFreeAccount) {
    return undefined
  }
  return JOTTACLOUD_ANDROID_PRODUCTS_URL
}
